module.exports = __webpack_public_path__ + "static/media/arrow_down1.356fb396.svg";